/**
 * Seleção de VÁRIAS tags (ids) — chips do que já foi escolhido + um combo para adicionar mais (com
 * criar na hora). Diferente do `PainelTags`, que aplica direto num cadastro: aqui é só escolher a
 * lista (ex.: as tags do lote de uma importação), que quem chama envia depois.
 */
import { X } from 'lucide-react';
import { useEffect, useMemo, useState } from 'react';
import { ComboReferencia } from '@/components/crud/ComboReferencia';
import { api, type TagCad } from '@/lib/api';

const COR_PADRAO = '#6aa9ff';

export function SeletorTags({
  valor,
  onChange,
}: {
  valor: string[];
  onChange: (ids: string[]) => void;
}) {
  const [catalogo, setCatalogo] = useState<TagCad[]>([]);
  const [sel, setSel] = useState('');

  async function recarregar() {
    const r = await api.get<TagCad[]>('/cadastro/tags');
    if (r.ok) setCatalogo(r.dados);
  }
  useEffect(() => {
    void recarregar();
  }, []);

  const porId = useMemo(() => new Map(catalogo.map((t) => [t.id, t])), [catalogo]);

  function adicionar(id: string) {
    setSel(''); // reseta o combo
    if (!id || valor.includes(id)) return;
    onChange([...valor, id]);
    void recarregar(); // pega a tag recém-criada para o chip mostrar o nome
  }

  return (
    <div className="flex flex-col gap-2">
      {valor.length > 0 && (
        <div className="flex flex-wrap gap-2">
          {valor.map((id) => {
            const t = porId.get(id);
            const cor = t?.cor || COR_PADRAO;
            return (
              <span
                key={id}
                className="inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-[13px]"
                style={{ borderColor: cor, color: cor, backgroundColor: `${cor}1a` }}
              >
                {t?.nome ?? '…'}
                <button
                  type="button"
                  onClick={() => onChange(valor.filter((x) => x !== id))}
                  aria-label="Remover tag"
                  className="rounded-full p-0.5 hover:bg-surface-hover"
                >
                  <X className="size-3.5" />
                </button>
              </span>
            );
          })}
        </div>
      )}
      <div className="max-w-md">
        <ComboReferencia
          id="seletor-tags"
          valor={sel}
          onChange={adicionar}
          endpoint="/cadastro/tags"
          permitirCriar
        />
      </div>
    </div>
  );
}
